import styled from 'styled-components';
import themeToken from '@lib/theme/tokens/index';
import SearchOutlined from '@ant-design/icons/SearchOutlined';

const StyledSearchOutlined = styled(SearchOutlined)`
  color: ${themeToken['branding-primary-6']};
  font-size: 18px;
`;

export default StyledSearchOutlined;
